"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class CategoryApi {
    constructor(api) {
        this.api = api;
    }
    //* -------------------------------------------------------------------------- */
    //*                                  Category                                  */
    //* -------------------------------------------------------------------------- */
    /**
     * 取得分類列表
     */
    getCategories(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/category";
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const response = yield this.api.axiosGo.get(endpoint, {
                headers,
            });
            return response.data;
        });
    }
    /**
     * 取得分類
     * @deprecated 目前沒有專案使用
     */
    getCategory(categoryId, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}`;
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const response = yield this.api.axiosGo.get(endpoint, {
                headers,
            });
            return response.data;
        });
    }
    /**
     * 新增分類
     */
    createCategory(category) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/category";
            const data = {
                name: category.name,
                desc: (_a = category.desc) !== null && _a !== void 0 ? _a : null,
                parentId: (_b = category.parentId) !== null && _b !== void 0 ? _b : "",
                locale: (_c = this.api.locale) !== null && _c !== void 0 ? _c : "zh",
                days: (_d = category.weekdays) !== null && _d !== void 0 ? _d : null,
                start: (_f = (_e = category.timerange) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : null,
                end: (_h = (_g = category.timerange) === null || _g === void 0 ? void 0 : _g[1]) !== null && _h !== void 0 ? _h : null,
                waiterOnly: (_j = category.waiterOnly) !== null && _j !== void 0 ? _j : null,
                takeawayOnly: (_k = category.takeawayOnly) !== null && _k !== void 0 ? _k : null,
                dineinOnly: (_l = category.dineinOnly) !== null && _l !== void 0 ? _l : null,
                excludedDiscount: (_m = category.excludedDiscount) !== null && _m !== void 0 ? _m : false,
                excludedSurcharge: (_o = category.excludedSurcharge) !== null && _o !== void 0 ? _o : false,
                code: (_p = category.code) !== null && _p !== void 0 ? _p : null,
                isSet: false,
                type: category.type,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類指定語言的名稱 (name) 和簡介 (desc)
     */
    updateCategoryTranslate(categoryId, data) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (data.locale == null) {
                data.locale = (_a = this.api.locale) !== null && _a !== void 0 ? _a : "zh";
            }
            const endpoint = `/m/category/${categoryId}/translate`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的父分類 (parentId)
     */
    updateCategoryParent(categoryId, parentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/parent`;
            const data = { parentId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的指定日子 (weekdays)
     */
    updateCategoryDays(categoryId, weekdays) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/days`;
            const data = { days: weekdays };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的開始時間與結束時間 (timerange)
     */
    updateCategoryTime(categoryId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/time`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的只限員工 (waiterOnly)
     */
    updateWaiterOnly(categoryId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/waiter`;
            const data = { waiterOnly: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的只限外賣 (takeawayOnly)
     */
    updateTakeawayOnly(categoryId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/takeawayonly`;
            const data = { takeawayOnly: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的只限堂食 (dineinOnly)
     */
    updateDineinOnly(categoryId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/dineinonly`;
            const data = { value: enabled };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的分類編號 (code)
     */
    updateCode(categoryId, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/code`;
            const data = { code };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的啟用 (enable)
     */
    updateCategoryEnable(categoryId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/enable`;
            const data = { enable: enabled };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
    /**
     * 修改分類的隱藏 (hidden)
     */
    updateCategoryHidden(categoryId, hidden) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/hidden`;
            const data = { hidden };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類的廚房部門 (kitchenDepartmentId)
     */
    updateCategoryDepartment(categoryId, kitchenDepartmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/kitchendepartment`;
            const data = { kitchenDepartmentId };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除分類
     */
    deleteCategory(categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
    updateCategoryOrderItemLimit(categoryId, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post(`/m/category/${categoryId}/orderitemlimit`, { value });
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                Category Tag                                */
    //* -------------------------------------------------------------------------- */
    /**
     * 取得分類標籤列表
     */
    getCategoryTag() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/categorytag";
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 新增分類標籤
     */
    createCategoryTag(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/categorytag";
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改分類標籤
     */
    updateCategoryTag(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/categorytag/${data.id}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除分類標籤
     */
    deleteCategoryTag(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/categorytag/${id}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
    /**
     * 排序分類標籤
     * @deprecated 目前沒有專案使用
     */
    reorderCategoryTag(categoryTagIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/merchant/sort/categorytag";
            const data = { categoryTagIds };
            yield this.api.axiosGo.post(endpoint, data);
        });
    }
}
exports.default = CategoryApi;
//# sourceMappingURL=Category.js.map